import React from 'react';
// import { Link, Redirect } from "react-router-dom";
import Cookies from 'js-cookie';
import {
	Card,
	Form,
	Input,
	Button,
	message,
	Typography,
	Row,
	Col,
} from 'antd';
import {
	SaveOutlined,
	RedoOutlined,
	FileTextOutlined,
	NumberOutlined,
	TagOutlined,
	SettingOutlined,
} from '@ant-design/icons';
import Config from '../../Config';
import BoxVisualList from '../../components/BoxVisualList';

import { connect } from 'react-redux';
import {
	initHandler,
	ajaxViewHandler,
	ajaxHandler,
	setConfig,
	extractResult,
} from "../../store/actions";
import { Helmet } from "react-helmet";
import ErrorAlertModal from '../../components/ErrorAlertModal';

const { Text } = Typography;

const configClass = {
	title: 'Pengaturan Notice',
	apiUrl: {
		preview: "kendaraan/api/pengaturan/notice/",
		box: "gudangnotice/api/box/",
	},
	breadCrumb: [
		<span><SettingOutlined /> Pengaturan</span>,
		'Notice',
	]
}

const config = new Config();

const FIELD_STYLE = {
	borderRadius: 8,
	height: 40,
};

class Notice extends React.Component {
	formRef = React.createRef();

	constructor(props) {
		super(props);

		this.config = new Config();
		this.state = {
			errComponent: false,
			errTitle: '',
			errMsg: '',
			loadingButton: false,

			aksi: 'tambah',
			method: 'post',
			idLama: '',

			isMobile: window.innerWidth <= 768,

			loadingBoxList: false, listBox: [],
		}
	}

	UNSAFE_componentWillMount() {
		this.props.initHandler();
	}

	componentDidMount() {
		this.preview();
		this.fetchBoxList();
		this._handleResize = () => this.setState({ isMobile: window.innerWidth <= 768 });
		window.addEventListener('resize', this._handleResize);
	}

	// Box yang ditampilkan di panel visual cukup dari upt_id sendiri (disimpan
	// global di Redux saat login, sama seperti kabupaten_id) - lihat
	// BoxNoticeViewset.get_queryset di be/gudangnotice/views.py yang sekarang
	// menerima filter upt_id eksplisit utk semua tingkat izin (selalu
	// mempersempit, tidak pernah memperluas dari lingkup yang sudah diizinkan).
	fetchBoxList = () => {
		if (!this.props.upt_id) return;
		this.setState({ loadingBoxList: true });
		this.props.ajaxViewHandler('get', `${configClass.apiUrl.box}?upt_id=${this.props.upt_id}&limit=50`)
			.then(() => {
				if (this.props.isSuccess) {
					const data = this.props.responseMsg;
					const list = Array.isArray(data) ? data : (data.results || []);
					this.setState({ listBox: list });
				}
				this.setState({ loadingBoxList: false });
			}).catch(() => this.setState({ loadingBoxList: false }));
	};

	componentWillUnmount() {
		window.removeEventListener('resize', this._handleResize);
	}

	async preview(id) {
		message.loading({ content: 'Menampilkan data sebelumnya...', duration: 0, key: 'toast' });
		Cookies.set(this.config.get_cookie_name() + "_username", Cookies.get(this.config.get_cookie_name() + "_username"), { expires:  new Date(new Date().getTime() + 30 * 60 * 1000)})
		

		this.props.ajaxViewHandler('get', configClass.apiUrl.preview)
			.then((action) => {
				const { isSuccess, responseMsg: data } = extractResult(action);
				if (isSuccess) {
					if (data.results.length > 0) {
						this.formRef.current.setFieldsValue(data.results[0]);
						this.setState({
							aksi: 'edit',
							method: 'put',
							idLama: data.results[0].id + '/'
						});
					} else {
						this.setState({
							aksi: 'tambah',
							method: 'post',
							idLama: ""
						});
					}
					message.destroy();
				} else {
					const errTitle = 'error preview data lama';
					this.setState({
						errTitle: errTitle,
						errMsg: data
					});
					message.error({ content: errTitle, duration: 2, key: 'toast' });
				}
			}).catch((response) => {
				console.log('gagal_get_preview', response);
				message.error({ content: 'gagal request data, coba lagi', duration: 2, key: 'toast' });
			});
	}

	handleSubmit = (values) => {
		var params = new FormData();
		for (var key in values) {
			if (key == 'gudang') {
				params.append(key, (values[key]).join());
			} else {
				params.append(key, (values[key]).toString());
			}
		}
		this.postData(params);
	}

	async postData(datas) {
		message.loading({ content: 'Memproses...', key: 'toast' });

		this.props.ajaxHandler(this.state.method, configClass.apiUrl.preview + this.state.idLama, datas, true, true)
			.then((action) => {
				this.setState({
					loadingButton: false
				});
				const { isSuccess, responseMsg } = extractResult(action);
				if (isSuccess) {
					message.success({ content: 'berhasil menyimpan data', duration: 2, key: 'toast' });
					this.setState({
						aksi: 'edit',
						method: 'put',
						idLama: responseMsg.id + '/'
					});
				} else {
					const errTitle = 'gagal menyimpan data'
					message.error({ content: errTitle, duration: 2, key: 'toast' });
					this.setState({
						errTitle: errTitle,
						errMsg: responseMsg
					});
				}
			}).catch((response) => {
				console.log('gagal_post', response);
				this.setState({
					loadingButton: false
				});
				message.error({ content: 'kesalahan pengiriman data, coba lagi', duration: 2, key: 'toast' });
			});
	}

	// Dikunci kalau UPT ini SEDANG punya box 'aktif' - di kondisi itu counter
	// sepenuhnya dikendalikan otomatis oleh sistem Gudang Notice (rebase saat
	// box diaktifkan, increment saat pembayaran), edit manual di sini tidak
	// pernah punya alasan legitimate dan hanya bisa bikin sisa stok/penerbitan
	// notice tidak sesuai (lihat insiden UPT Palangka Raya). UPT yang belum
	// punya box aktif (baik belum adopsi Gudang Notice sama sekali, maupun
	// sedang nunggu alokasi) tetap bebas diedit - di kondisi itu edit di sini
	// aman (akan ditimpa otomatis begitu box aktif, atau memang satu-satunya
	// mekanisme bagi UPT yang masih pakai counter lama tanpa box).
	_hasBoxAktif = () => this.state.listBox.some((b) => b.status === 'aktif');

	renderBoxVisual() {
		const { listBox, loadingBoxList } = this.state;
		return (
			<Card
				style={{ borderRadius: 14, boxShadow: '0 4px 20px rgba(0,0,0,0.07)', overflow: 'hidden', height: '100%' }}
				bodyStyle={{ padding: 20 }}
			>
				<BoxVisualList listBox={listBox} loading={loadingBoxList} />
			</Card>
		);
	}

	render() {
		const { isMobile, errMsg, errTitle, loadingButton, errComponent } = this.state;
		const hasBoxAktif = this._hasBoxAktif();

		return (
			<div>
				<Helmet>
					<title>{configClass.title + " | " + config.get_site_info().name}</title>
					<style>{`
						.form-notice-wrap .ant-form-item-label > label {
							font-weight: 600;
							color: #374151;
							font-size: 13px;
						}
						.form-notice-wrap .ant-input {
							border-radius: 8px !important;
						}
						.form-notice-wrap .ant-input:focus {
							border-color: #1e4d8a !important;
							box-shadow: 0 0 0 2px rgba(30,77,138,0.1) !important;
						}
					`}</style>
				</Helmet>


				<ErrorAlertModal
					visible={errMsg !== ''}
					title={errTitle}
					error={errMsg}
					onClose={() => this.setState({ errTitle: '', errMsg: '' })}
				/>

				<Row gutter={20}>
				<Col xs={24} lg={14}>
				<Form
					layout="vertical"
					name="fdata"
					onFinish={this.handleSubmit}
					ref={this.formRef}
					className="form-notice-wrap"
				>
					<Card
						style={{
							borderRadius: 14,
							boxShadow: '0 4px 20px rgba(0,0,0,0.07)',
							overflow: 'hidden',
						}}
						bodyStyle={{ padding: 0 }}
					>
						{/* Header */}
						<div style={{
							background: 'linear-gradient(135deg, #0f2847, #1e4d8a)',
							padding: '20px 24px',
							display: 'flex',
							alignItems: 'center',
							gap: 16,
						}}>
							<div style={{
								width: 52,
								height: 52,
								borderRadius: 14,
								background: 'rgba(255,255,255,0.15)',
								display: 'flex',
								alignItems: 'center',
								justifyContent: 'center',
								flexShrink: 0,
							}}>
								<FileTextOutlined style={{ color: '#fff', fontSize: 24 }} />
							</div>
							<div style={{ flex: 1, minWidth: 0 }}>
								<div style={{ color: '#fff', fontWeight: 700, fontSize: 18, lineHeight: 1.3 }}>
									{configClass.title}
								</div>
								<div style={{ color: 'rgba(255,255,255,0.65)', fontSize: 13, marginTop: 3 }}>
									Atur nomor dan kode untuk pencetakan notice
								</div>
							</div>
						</div>

						{/* Section header */}
						<div style={{
							padding: '14px 24px',
							background: 'linear-gradient(135deg, #0f284711, #1e4d8a11)',
							borderBottom: '1.5px solid #d0dff5',
							display: 'flex',
							alignItems: 'center',
							gap: 10,
						}}>
							<FileTextOutlined style={{ color: '#1e4d8a', fontSize: 16 }} />
							<Text strong style={{ fontSize: 14, color: '#0f2847' }}>
								Informasi Notice
							</Text>
						</div>

						{/* Form fields */}
						<div style={{ padding: '24px 28px' }}>
							{hasBoxAktif && (
								<div style={{
									background: '#fffbe6', border: '1px solid #ffe58f', borderRadius: 8,
									padding: '10px 14px', marginBottom: 18, fontSize: 12.5, color: '#874d00',
								}}>
									Nomor &amp; kode dikunci karena UPT ini sedang punya box notice aktif - keduanya
									dikelola otomatis oleh sistem Gudang Notice (lihat panel di samping).
								</div>
							)}
							<Form.Item
								label={<span><NumberOutlined style={{ color: '#1e4d8a', marginRight: 6 }} />Nomor</span>}
								name="nomor"
								rules={[{ required: true, message: 'Nomor harus diisi' }]}
							>
								<Input placeholder="Nomor notice..." style={FIELD_STYLE} disabled={hasBoxAktif} />
							</Form.Item>

							<Form.Item
								label={<span><TagOutlined style={{ color: '#1e4d8a', marginRight: 6 }} />Kode</span>}
								name="kode"
								rules={[{ required: true, message: 'Kode harus diisi' }]}
								style={{ marginBottom: 0 }}
							>
								<Input placeholder="Kode notice..." style={FIELD_STYLE} disabled={hasBoxAktif} />
							</Form.Item>
						</div>

						{/* Footer tombol */}
						<div style={{
							padding: '16px 28px',
							display: 'flex',
							gap: 10,
							justifyContent: isMobile ? 'stretch' : 'flex-end',
							flexDirection: isMobile ? 'column' : 'row',
							background: '#fafafa',
							borderTop: '1px solid #f0f0f0',
						}}>
							<Button
								icon={<RedoOutlined />}
								size="large"
								disabled={loadingButton}
								onClick={() => this.preview()}
								style={{ borderRadius: 10, ...(isMobile ? { width: '100%' } : {}) }}
							>
								Muat Ulang
							</Button>
							<Button
								type="primary"
								htmlType="submit"
								icon={<SaveOutlined />}
								size="large"
								loading={loadingButton}
								disabled={errComponent || hasBoxAktif}
								style={{
									borderRadius: 10,
									background: 'linear-gradient(135deg, #0f2847, #1e4d8a)',
									border: 'none',
									fontWeight: 600,
									...(isMobile ? { width: '100%' } : {}),
								}}
							>
								Simpan
							</Button>
						</div>
					</Card>
				</Form>
				</Col>
				<Col xs={24} lg={10} style={{ marginTop: isMobile ? 20 : 0 }}>
					{this.renderBoxVisual()}
				</Col>
				</Row>
			</div>
		);
	}
}

const mapStateToProps = function (state) {
	return state.configReducers
}

export default connect(
	mapStateToProps,
	{
		initHandler,
		setConfig,
		ajaxViewHandler,
		ajaxHandler
	}
)(Notice);